import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const ScaleRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const min = question.settings?.minValue || 1;
  const max = question.settings?.maxValue || 5;
  const scaleLabels = question.settings?.scaleLabels || [];

  const scaleValues = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  const handleChange = (scaleValue: number) => {
    onChange(scaleValue);
  };

  return (
    <div>
      <div className="flex flex-col space-y-2">
        {scaleValues.map((scaleValue, index) => {
          const isSelected = value === scaleValue;
          const label = scaleLabels[index];

          return (
            <label
              key={scaleValue}
              className={`flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all ${
                isSelected
                  ? 'border-blue-500 bg-blue-50'
                  : error
                  ? 'border-red-200 hover:border-red-300'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <input
                type="radio"
                name={question.id}
                value={scaleValue}
                checked={isSelected}
                onChange={() => handleChange(scaleValue)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <div className="ml-3 flex items-center">
                <span className="font-semibold text-gray-900 w-8">{scaleValue}</span>
                {label && (
                  <span className="text-gray-700 ml-4">{label}</span>
                )}
              </div>
            </label>
          );
        })}
      </div>

      {/* Scale range labels */}
      {scaleLabels.length > 0 && (scaleLabels[0] || scaleLabels[scaleLabels.length - 1]) && (
        <div className="flex justify-between mt-4 text-sm text-gray-600">
          <span>{scaleLabels[0] || ''}</span>
          <span>{scaleLabels[scaleLabels.length - 1] || ''}</span>
        </div>
      )}
    </div>
  );
};

export default ScaleRenderer;
